import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones.jsx";

/*
 * Modal os dados de um json.
 */
function ModalInfoJson({ modalOpen, toggleModal, titulo, infoJson }) {
  function renderInfo(info) {
    return Object.entries(info).map(([key, value]) => (
      <tr key={key}>
        <td width="20%" className="fw-bold">
          {key}
        </td>
        <td>
          {typeof value === "object" && value !== null ? (
            <table>
              <tbody>{renderInfo(value)}</tbody>
            </table>
          ) : (
            value?.toString()
          )}
        </td>
      </tr>
    ));
  }

  return (
    <Modal isOpen={modalOpen} backdrop="static" size="lg">
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        {titulo || "Informações"}
      </ModalHeader>

      <ModalBody>
        <div style={{ overflowY: "auto", maxHeight: "300px" }}>
          <Table responsive bordered striped>
            <tbody>{renderInfo(infoJson)}</tbody>
          </Table>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button name="btnFechar" color="secondary" onClick={toggleModal}>
          {ICONES_BOTAO.FECHAR} Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalInfoJson;
